import { useEffect } from 'react'

import { SHELL_PRESENCE } from '../composition/shell'
import { useAppDispatch } from './hooks'

/**
 * «Я в системе» (RP-SE13): пока вкладка видима, клиент раз в минуту говорит об этом службам модулей, которые объявили присутствие
 * (`UiModule.shell.presence`). Первый сигнал после тишины запускает у службы проверку источников: каталог не должен ждать расписания,
 * когда в систему пришли. Открытие раздела «Номенклатура» сигналов не добавляет, а ошибка сигнала человеку не показывается: он нужен
 * только для того, чтобы каталог был свежим.
 */
export function usePresence(): void {
  const dispatch = useAppDispatch()
  useEffect(() => {
    const send = () => {
      if (document.visibilityState !== 'visible') return
      for (const presence of SHELL_PRESENCE) presence.ping(dispatch).catch(() => undefined)
    }
    send()
    // Свой таймер на каждое присутствие: интервал объявляет модуль.
    const timers = SHELL_PRESENCE.map((presence) =>
      window.setInterval(() => {
        if (document.visibilityState === 'visible') presence.ping(dispatch).catch(() => undefined)
      }, presence.intervalMs),
    )
    document.addEventListener('visibilitychange', send)
    return () => {
      for (const timer of timers) window.clearInterval(timer)
      document.removeEventListener('visibilitychange', send)
    }
  }, [dispatch])
}
